module.exports = __webpack_public_path__ + "img/row1.1216605.webp";